import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

export const NodeHeader = ({ nodeTitle }: { nodeTitle: string }) => {
  return (
    <HeaderWrapper>
      <TitleWrapper>
        <Typography variant="caption" fontWeight={700}>
          {nodeTitle}
        </Typography>
      </TitleWrapper>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 8,
});

const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});
